<template>
  <div class="product-description-text">
    <h2 class="product-description-text__headline">
      <span
        v-if="productDetails.product.vintage"
        class="product-description-text__vintage"
      >
        {{ productDetails.product.vintage }}
      </span>
      <span
        class="product-description-text__descr1"
      >
        {{ description1 }}
      </span>
    </h2>
    <read-more
      text-more="ads.main.detail.read_more"
      text-less="ads.main.detail.read_less"
      :max-height="140"
    >
      <div
        class="product-description-text__description"
        v-html="longDescription"
      />
    </read-more>
  </div>
</template>

<script lang="ts">
  import ProductDescriptionText from '../../../bps/components/productDescriptionText/productDescriptionText.vue';
  export default ProductDescriptionText;
</script>
